import { connect } from 'react-redux'
import { updateUser, refreshUsers } from 'redux/modules/user'
import { showModal } from 'redux/modules/modals'
import UsersComponent from '../components/UsersComponent'

const mapActionCreators = {
  updateUser,
  refreshUsers,
  showModal
}

const mapStateToProps = state => {
  return {
    users: state.users.list
  }
}

export default connect(mapStateToProps, mapActionCreators)(UsersComponent)



// WEBPACK FOOTER //
// ./src/routes/Admin/Users/containers/AdminUsersContainer.js